import apiClient from './apiClient';
import { io } from 'socket.io-client';
import ENV from '../../config/env';

export const fetchNotifications = async () => {
  const response = await apiClient.get('/notifications');
  return response.content || [];
};

export const fetchUnreadCount = async () => {
  const response = await apiClient.get('/notifications/unread-count');
  return response.isSuccessful && typeof response.content === 'number' ? response.content : 0;
};

export const clearAllNotifications = async () => {
  const response = await apiClient.delete('/notifications/clear-all');
  return response;
};

export const markAllNotificationsAsRead = async () => {
  const response = await apiClient.post('/notifications/mark-all-read');
  return response;
};

export const markNotificationAsRead = async (id) => {
  const response = await apiClient.get(`/notifications/${id}/mark-read`);
  return response;
};

export const fetchNotificationById = async (id) => {
  const response = await apiClient.get(`/notifications/${id}`);
  return response.content;
};

export const deleteNotification = async (id) => {
  const response = await apiClient.delete(`/notifications/${id}`);
  return response;
};

export const getNotificationPreference = async () => {
  const response = await apiClient.get('/notifications/preference');
  return response.content || { enabled: false };
};

export const toggleNotificationPreference = async (enabled) => {
  const response = await apiClient.post('/notifications/toggle', { enabled });
  return response;
};

export const initiateNotificationSocket = (token, onNotificationReceived, onReconnect) => {
  if (!token) return null;

  let socketUrl = 'http://localhost:8081';
  if (ENV.API_URL) {
    try {
      const urlObj = new URL(ENV.API_URL);
      socketUrl = `${urlObj.protocol}//${urlObj.host}`;
    } catch (e) {
      socketUrl = ENV.API_URL.replace(/\/api\/v1\/web$/, '').replace(/\/api\/v1$/, '').replace(/\/api$/, '');
    }
  }

  const socket = io(`${socketUrl}/notifications`, {
    transports: ['websocket'],
    forceNew: true,
    reconnection: true
  });

  socket.on('connect', () => {
    socket.emit('authenticate', { token }, (ack) => {
      if (onReconnect) {
        onReconnect();
      }
    });
  });

  socket.on('notification', (data) => {
    if (onNotificationReceived) {
      onNotificationReceived(data);
    }
  });

  socket.on('connect_error', (err) => {
    console.error('Notification socket connection error:', err);
  });

  return socket;
};

export const initiateExamSocket = (token, onForceDisconnect) => {
  if (!token) return null;

  let socketUrl = 'http://localhost:8081';
  if (ENV.API_URL) {
    try {
      const urlObj = new URL(ENV.API_URL);
      socketUrl = `${urlObj.protocol}//${urlObj.host}`;
    } catch (e) {
      socketUrl = ENV.API_URL.replace(/\/api\/v1\/web$/, '').replace(/\/api\/v1$/, '').replace(/\/api$/, '');
    }
  }

  let deviceId = localStorage.getItem('exam_device_id');
  if (!deviceId) {
    deviceId = 'device_' + Math.random().toString(36).substring(2, 15) + '_' + Date.now();
    localStorage.setItem('exam_device_id', deviceId);
  }

  const socket = io(`${socketUrl}/student-exam`, {
    transports: ['websocket'],
    forceNew: true,
    reconnection: true
  });

  socket.on('connect', () => {
    socket.emit('authenticate', { token, deviceId }, (ack) => {
    });
  });

  socket.on('force-disconnect', (data) => {
    if (onForceDisconnect) {
      onForceDisconnect(data);
    }
  });

  socket.on('connect_error', (err) => {
    console.error('Exam socket connection error:', err);
  });

  return socket;
};

export const notificationService = {
  fetchNotifications,
  fetchUnreadCount,
  clearAllNotifications,
  markAllNotificationsAsRead,
  markNotificationAsRead,
  fetchNotificationById,
  deleteNotification,
  getNotificationPreference,
  toggleNotificationPreference,
  initiateNotificationSocket,
  initiateExamSocket
};

export default notificationService;
